<template>
  <div>
    <header class="card__container">
      <!-- Customer Detail Start -->
      <div class="header__container">
        <label class="text__header">Create New Site Access Request</label>

        <div class="d-flex flex-wrap">
          <label class="text__customer-detail_topic">Customer Name</label>
          <label class="text__customer-detail_data ml-md-2">{{
            customerName
          }}</label>
        </div>
        <div class="d-flex flex-wrap">
          <label class="text__customer-detail_topic">{{
            contractIdLabel
          }}</label>
          <label class="text__customer-detail_data ml-md-2">{{
            idcId
          }}</label>
        </div>
      </div>
      <!-- Customer Detail End -->

      <hr />

      <!-- QR Access Detail Start -->
      <div class="header__container d-flex flex-column col-12 col-lg-6">
        <div class="d-lg-flex w-100">
          <div class="col-12 col-lg-6 px-0 pr-lg-1">
            <atom-datepicker
              datepickerId="request-start-date"
              title="Request Start Date"
              :isAsterisk="true"
              v-model="requestDetail.startDate"
              placeholder="Request Start Date"
              :minDate="todayDatetime"
              :maxDate="requestDetail.endDate"
              type="dateNtime"
              :isError="validateRequestDetailError.startDate"
              errorMessage="Please enter start date"
            ></atom-datepicker>
          </div>
          <div class="col-12 col-lg-6 px-0 mt-1 mt-lg-0 pl-lg-1">
            <atom-datepicker
              datepickerId="request-end-date"
              title="Request End Date"
              :isAsterisk="true"
              v-model="requestDetail.endDate"
              placeholder="Request End Date"
              :minDate="requestDetail.startDate"
              :maxDate="maxSiteAccessRequestEndDate"
              type="dateNtime"
              :isError="validateRequestDetailError.endDate"
              errorMessage="Please enter end date"
            ></atom-datepicker>
          </div>
        </div>

        <atom-text-area
          v-model="requestDetail.description"
          title="Description"
          placeholder="Description"
          :isAsterisk="true"
          :isError="validateRequestDetailError.description"
          errorMessage="Please enter description"
          class="mt-1"
        ></atom-text-area>

        <div class="mt-1">
          <b-alert :show="true" variant="secondary" class="w-100">
            <div class="alert-body">
              <strong>Please Note:</strong> Please specify the entry and
              exit date/time to cover your entire visit. <br />Access is
              not permitted before the Start Date or after the End Date.
              <br />For visits longer than one day, you can specify a date
              range in a single Site Access request.
            </div>
          </b-alert>
        </div>
      </div>
      <!-- QR Access Detail End -->
    </header>

    <!-- Visitor Detail Start -->
    <molecule-visitor-card-group
      :visitorListProp="visitorList"
      :validateVisitorError="validateRequestDetailError.visitor"
      class="mt-30px"
      @updateVisitorList="onUpdateVisitorList"
    />
    <!-- Visitor Detail End -->

    <!-- Button Start -->
    <div class="d-flex justify-content-end mt-30px">
      <atom-button
        buttonId="btn__create"
        :isDisable="isRequestDetailError"
        @click="onClickCreate"
        >Create and Send request</atom-button
      >
      <atom-button
        buttonId="btn__cancle"
        buttonStyle="border"
        buttonColor="secondary"
        @click="onClickCancel"
        class="ml-12px"
        >Cancel</atom-button
      >
    </div>
    <!-- Button End -->

    <!-- Modal Start -->
    <div>
      <!-- Modal Confirm Create Request -->
      <molecule-modal-dialog
        modalId="modal-confirm-create-request"
        buttonTextLeft="Confirm"
        :isTextCenter="true"
        :textTitle="`Do you want to create\nSite Access ?`"
        @clickButtonLeft="onClickConfirmCreate"
        @clickButtonRight="closeModal"
        @clickIconClose="closeModal"
      ></molecule-modal-dialog>

      <!-- Modal Confirm Discard Create request -->
      <molecule-modal-dialog
        modalId="modal-confirm-discard-new-request"
        :isTextCenter="true"
        :textTitle="`Do you want to leave\nwithout finishing ?`"
        buttonTextLeft="Confirm"
        @clickButtonLeft="onClickConfirmDiscard"
      >
      </molecule-modal-dialog>
    </div>
    <!-- Modal End -->
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { getVisitorsById } from "@/api/module-1/site-access"
import mixins from "@/mixins"
import mixinsValidator from "@/mixins/mixinsValidator"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomDatepicker from "@/components/atoms/AtomDatepicker.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import MoleculeVisitorCardGroup from "@/components/molecules/portal/qrAccess/MoleculeVisitorCardGroup.vue"
import mixinsSiteHelper from "@/mixins/mixinsSiteHelper"
import { DateTime } from "luxon"
import { BAlert } from "bootstrap-vue"

export default {
  name: "OrganismQrAccessCreateNew",
  components: {
    AtomButton,
    AtomDatepicker,
    AtomTextArea,
    MoleculeModalDialog,
    MoleculeVisitorCardGroup,
    BAlert
  },
  mixins: [mixins, mixinsValidator, mixinsObjectHelper, mixinsSiteHelper],
  props: {},
  emits: ["createSiteAccess"],
  data() {
    return {
      customer: {
        name: "",
        idcId: "",
        siteId: "",
        siteName: ""
      },

      modalId: null,

      requestDetail: {
        startDate: DateTime.now()
          .startOf("day")
          .set({ second: 0, millisecond: 0 })
          .toISO({ suppressMilliseconds: true }),
        endDate: DateTime.now()
          .endOf("day")
          .plus({ days: 7 })
          .set({ second: 0, millisecond: 0 })
          .toISO({ suppressMilliseconds: true }),
        description: null
      },

      isApplyValidateRequestDetail: false,
      validateRequestDetailError: {
        startDate: false,
        endDate: false,
        description: false,
        visitor: false
      },

      visitorList: []
    }
  },
  computed: {
    ...mapGetters("appPermission", [
      "getFullName",
      "getIdcId",
      "getCustomerSitePermissions"
    ]),

    siteAccessIdParams() {
      return this.$route.params.siteAccessId
    },

    isRequestDetailError() {
      return Object.values(this.validateRequestDetailError).some(
        (error) => error === true
      )
    },

    customerName() {
      return this.getFullName || "-"
    },

    idcId() {
      return !!this.getIdcId
        ? this.getIdcId.toString().padStart(8, "0")
        : "-"
    },

    maxSiteAccessRequestEndDate() {
      if (!this.requestDetail.startDate) return null

      return DateTime.fromISO(this.requestDetail.startDate)
        .plus({ days: 30 })
        .set({ hour: 23, minute: 59, second: 59 })
        .toISO({ suppressMilliseconds: true })
    },

    todayDatetime() {
      return DateTime.now()
        .startOf("day")
        .set({ second: 0, millisecond: 0 })
        .toISO({ suppressMilliseconds: true })
    },
  },
  watch: {
    requestDetail: {
      deep: true,
      handler() {
        this.validateRequestDetail()
      }
    },
    visitorList: {
      deep: true,
      handler() {
        this.validateRequestDetail()
      }
    }
  },
  async mounted() {
    if (this.siteAccessIdParams) {
      await this.getCopyVisitorList()
    }
  },
  methods: {
    async getCopyVisitorList() {
      this.showLoading(true)
      await getVisitorsById(this.siteAccessIdParams, false)
        .then((response) => {
          this.visitorList = response.visitors.map((visitor) => {
            return {
              id: visitor.accessVisitorId,
              firstname: visitor.firstname,
              lastname: visitor.lastname,
              idType: {
                id: visitor.idType,
                name: visitor.idType === "ID_CARD" ? "ID Card" : "Passport"
              },
              idNumber: visitor.identity,
              email: visitor.email,
              phone: visitor.phone
            }
          })
        })
        .finally(() => {
          this.showLoading(false)
        })
    },

    // Visitor Start
    onUpdateVisitorList(visitorList) {
      this.visitorList = this.deepCopyArray(visitorList)
    },
    // Visitor End

    onClickCreate() {
      this.isApplyValidateRequestDetail = true

      this.validateRequestDetail()

      if (!this.isRequestDetailError) {
        this.openModal("modal-confirm-create-request")
      }
    },

    onClickConfirmCreate() {
      const requestCreateNewSiteAccess = {
        idcId: this.idcId,
        description: this.requestDetail.description,
        requestStartDate: this.requestDetail.startDate,
        requestEndDate: this.requestDetail.endDate,
        siteId: this.getCustomerSitePermissions?.find(
          (x) => x !== undefined
        ),
        visitors: this.visitorList.map((visitor) => ({
          firstname: visitor.firstname,
          lastname: visitor.lastname,
          idType: visitor.idType.id,
          identity: visitor.idNumber,
          email: visitor.email,
          phone: visitor.phone
        }))
      }
      this.$emit("createSiteAccess", requestCreateNewSiteAccess)

      this.closeModal()
    },

    onClickCancel() {
      this.openModal("modal-confirm-discard-new-request")
    },

    onClickConfirmDiscard() {
      this.closeModal()
      this.$router.push("/web-portal/site-access")
    },

    validateRequestDetail() {
      if (!this.isApplyValidateRequestDetail) {
        this.validateRequestDetailError = this.deepCopyObject({
          startDate: false,
          endDate: false,
          description: false,
          visitor: false
        })
      } else {
        this.validateRequestDetailError = this.deepCopyObject({
          startDate: !this.requestDetail.startDate,
          endDate: !this.requestDetail.endDate,
          description: this.isEmptyString(this.requestDetail.description),
          visitor: this.visitorList.length === 0
        })
      }
    },

    // Modal Start
    openModal(modalId) {
      this.modalId = modalId
      this.$bvModal.show(this.modalId)
    },

    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    }
    // Modal End
  }
}
</script>

<style lang="scss" scoped>
hr {
  width: 100%;
  stroke-width: 1px;
  stroke: #e9ecef;
}

.card__container {
  width: 100%;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.06);
}

.header__container {
  padding: 30px;
}

.text__header {
  color: #5e5873;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 35px;
}

.text__customer-detail_topic {
  font-size: 14px;
  font-weight: 600;
  color: #6e6b7b;
  width: 130px;
}

.text__customer-detail_data {
  font-size: 14px;
  font-weight: 400;
  color: #5e5873;
}

.mt-30px {
  margin-top: 30px;
}

.ml-12px {
  margin-left: 12px;
}
</style>
